<ng-container *ngIf="!field.multiple">
    <div [formGroup]="group">
        <mat-slide-toggle class="mat-primary"
            [disabled]="field.disabled"
            [formControlName]="field.name">
            {{field.label + (field.required ? ' *' : '')}}
        </mat-slide-toggle>
    </div>
</ng-container>
